import i18n from '@/plugins/i18n'

export const locale = {
  getMessage,
  getArrayMessage,
  getName,
  getCurrentLanguage,
  setCurrentLanguage
}

function getCurrentLanguage() {
  return i18n.locale
}

function setCurrentLanguage(language) {
  i18n.locale = language
}

// nagad88.com keeps the legacy brand first in page titles: "Nagad88 (NG88)" instead of "NG88 (Nagad88)"
const isNagad88Com = /(^|\.)nagad88\.com$/i.test(window.location.hostname)

function getMessage(key, dynamicValue = null) {
  const message = dynamicValue == null ? i18n.t(key) : i18n.t(key, dynamicValue)
  if (isNagad88Com && typeof key === 'string' && key.startsWith('meta.') && typeof message === 'string') {
    return message
      .split('NG88 (Nagad88)').join('Nagad88 (NG88)')
      .split('NG88 (formerly Nagad88)').join('Nagad88 (NG88)')
      .split('NG88 (পূর্বে Nagad88)').join('Nagad88 (NG88)')
  }
  return message
}

function getArrayMessage(key, array) {
  let result = []

  for (let i = 0; i < array.length; i++) {
    result.push(i18n.t(`${key}.${array[i].toLowerCase()}`))
  }

  return result.join(', ')
}

function getName(value) {
  let result = ''

  if (value != undefined && value != null && value != '') {
    let str = typeof value === 'string' ? value : JSON.stringify(value)
    let localeStartIndex = str.indexOf(`"${i18n.locale}"`)

    if (localeStartIndex > 0) {
      let localeStr = str.slice(localeStartIndex + 6, str.length)
      let localeEndIndex = localeStr.indexOf('"')

      result = localeStr.slice(0, localeEndIndex)
    } else if (localeStartIndex == -1) {
      //get value from other language
      localeStartIndex = str.indexOf(`":"`)
      let localeStr = str.slice(localeStartIndex + 3, str.length)
      let localeEndIndex = localeStr.indexOf('"')

      result = localeStr.slice(0, localeEndIndex)
    }
  }

  return result
}
